import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '@eng-ds/translate';
import { SelectOption } from '../models';

@Pipe({
	name: 'addClearOption',
	standalone: true
})
export class AddClearOptionPipe implements PipeTransform {
	/**
	 * DI
	 */
	private i18nService = inject(I18nService);

	transform(options: SelectOption[], addClear: boolean): SelectOption[] {
		let optionsReturn: SelectOption[] = [];

		if (addClear) {
			optionsReturn.push({
				label: this.i18nService.translate('UTILS.SELECT.CLEAR_CHOICE'),
				value: undefined
			});
		}

		if (Array.isArray(options)) {
			optionsReturn = optionsReturn.concat(options);
		}

		return optionsReturn;
	}
}
